import {HIGH_TO_LOW, LOW_TO_HIGH} from '../constants';

export const sortStringToGraphQLSort = sortString => {
  return (
    {
      [HIGH_TO_LOW]: {
        price: 'DESC',
      },
      [LOW_TO_HIGH]: {
        price: 'ASC',
      },
    }[sortString] || undefined
  );
};

const convertSwatchType = type => {
  return {
    COLOR: 1,
    IMAGE: 2,
    TEXT: 3,
  }[type];
};

export const mapFacets = ({facets = [], excluded = []}) =>
  facets
    .filter(({key}) => !excluded.includes(key))
    .filter(({options}) => options.length > 0)
    .map(f => ({
      label: f.label,
      attribute_code: f.key,
      options: f.options.map(o => ({
        label: o.label,
        value: o.value,
        count: o.resultCount,
        swatch_data: o.swatch && {
          type: convertSwatchType(o.swatch.type),
          value: o.swatch.value,
        },
      })),
    }));

export default {};
